/**
 * Changes the input field of the form
 *
 * @param  {form} form The new text of the input field
 *
 * @return {object}    An action object with a type of CHANGE_USERNAME
 */
import {
  SAVE,
  VALUE_CHANGED,
  LOAD,
  RESET,
  LOAD_CLIENT_INFO,
  RESET_GIVE_PERMISSION_STATE,
  RESET_OTHER_INSURANCE_STATE,
} from './constants';

export function saveFormData(form) {
  return {
    type: SAVE,
    payload: form,
  };
}

export function loadFormData(form) {
  return {
    type: LOAD,
    payload: form,
  };
}

export function handleFormDataChange(propertyName, value) {
  return {
    type: VALUE_CHANGED,
    propertyName,
    value,
  };
}

export function resetFormData() {
  return {
    type: RESET,
  };
}

export function loadClientDetail(clientDetail) {
  return {
    type: LOAD_CLIENT_INFO,
    clientDetail,
  };
}

export function resetFormOtherInsuranceState() {
  return {
    type: RESET_OTHER_INSURANCE_STATE,
  };
}

export function resetFormGivePermissionState() {
  return {
    type: RESET_GIVE_PERMISSION_STATE,
  };
}



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step2/actions.js